import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant';
import 'vant/lib/index.css';

import "@/request.js";
// import axios from 'axios'

import InfiniteLoading from 'vue-infinite-loading';

Vue.config.productionTip = false

Vue.use(InfiniteLoading, { /* options */ });
Vue.use(Vant);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
